import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface SignupInvitationInvalidProps {
  emailFromUrl?: string | null;
  isResending: boolean;
  resendSent: boolean;
  onResend: (email: string) => void;
  loginHref?: string;
}

export function SignupInvitationInvalid({
  emailFromUrl,
  isResending,
  resendSent,
  onResend,
  loginHref = '/login',
}: SignupInvitationInvalidProps) {
  const [email, setEmail] = useState(emailFromUrl ?? '');

  useEffect(() => {
    if (emailFromUrl) {
      setEmail(emailFromUrl);
    }
  }, [emailFromUrl]);

  const trimmedEmail = email.trim();
  const canResend = trimmedEmail.length > 0 && !isResending;

  const handleResend = () => {
    if (!trimmedEmail || isResending) {
      return;
    }
    onResend(trimmedEmail);
  };

  return (
    <div className="bg-white rounded-lg border p-6 flex flex-col w-full sm:w-96 gap-4">
      <div className="text-center">
        <h1 className="text-xl font-sans font-semibold text-gray-900 mb-2 text-center leading-none">
          Link expirado ou inválido
        </h1>
        <p className="text-sm font-sans font-normal text-muted-foreground text-center">
          O link de cadastro expirou ou não é mais válido. Solicite um novo link para continuar.
        </p>
      </div>

      <div>
        <label htmlFor="resend-email" className="block text-sm font-medium text-gray-700 mb-1">
          E-mail
        </label>
        <Input
          id="resend-email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="Digite seu email"
          disabled={isResending || !!emailFromUrl}
        />
      </div>

      {resendSent && (
        <p className="text-sm font-sans font-normal text-muted-foreground text-center">
          Se o e-mail existir, enviamos um novo link.
        </p>
      )}

      <Button
        type="button"
        disabled={!canResend}
        onClick={handleResend}
        className="w-full bg-black text-white hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isResending ? 'Reenviando...' : 'Reenviar link'}
      </Button>

      <div className="text-center">
        <span className="text-sm text-black">Já possui uma conta? </span>
        <Link to={loginHref} className="text-sm text-black underline">
          Entrar.
        </Link>
      </div>
    </div>
  );
}
